<template>
  <menu-page />
</template>

<script>
  import MenuPage from '@/components/MenuPage'

  export default {
    name: 'HomeView',

    components: {
      MenuPage,
    },
   
  }
</script>
